/**
 * Scroll to a landing-page section, offset for the fixed header (and promo banner).
 */
export function getLandingScrollOffset(): number {
  if (typeof document === 'undefined') return 120;

  const root = document.documentElement;
  const base =
    parseInt(getComputedStyle(root).getPropertyValue('--header-base-offset'), 10) || 120;
  const banner =
    parseInt(getComputedStyle(root).getPropertyValue('--header-banner-height'), 10) || 0;

  return base + banner;
}

export function scrollToLandingSection(
  sectionId: string,
  options?: { smooth?: boolean; updateHash?: boolean }
): boolean {
  if (typeof window === 'undefined') return false;

  const target = document.getElementById(sectionId);
  if (!target) return false;

  const smooth = options?.smooth ?? true;
  const updateHash = options?.updateHash ?? true;
  const top =
    target.getBoundingClientRect().top + window.scrollY - getLandingScrollOffset();

  window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });

  if (updateHash) {
    window.history.pushState(null, '', `#${sectionId}`);
  }

  return true;
}
